import { getAxios } from '../../axios';
import { 
  ENDPOINT_NEO_COUNTIES,
  ENDPOINT_NEO_CITIES, 
} from '../../../config/endpoints';
import {
  addParam,
  errorCatch,
  getTokenHeaders,
} from '../../helper';
import { Messages } from '../../../config';

/**
 * Get neo counties list
 * @param {object} payload
 * @param {string} payload.notificationId
 * @returns {Promise<T>}
 */
export function getCounties(payload) {
  
  return getAxios(false).get(
    addParam(
      ENDPOINT_NEO_COUNTIES
    ),
    getTokenHeaders()
  )
  .then(
    data => {
      return data && data.data ? data.data : null
    }
  )
  .catch(
    e => {
      errorCatch(
        e,
        {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        },
        payload.notificationId || null
      );
      return e?.response;
    }
  );
}

/**
 * Get neo cities list
 * @param {object} payload
 * @param {string} payload.notificationId
 * @param {number} payload.urlParams.county
 * @returns {Promise<T>}
 */
export function getCities(payload) {
  return getAxios(false).get(
    addParam(
      ENDPOINT_NEO_CITIES,
      {},
      null,
      {
        'county': payload.urlParams.county
      }
    ),
    getTokenHeaders(),
  )
  .then(
    data => {
      return data && data.data ? data.data : null
    }
  )
  .catch(
    e => {
      errorCatch(
        e,
        {
          400: 'concat',
          401: Messages.UNAUTHENTICATED_ERROR,
          403: Messages.UNAUTHORIZED_ERROR,
          404: Messages.NOT_FOUND_ERROR,
        },
        payload.notificationId || null
      );
      return e?.response;
    }
  );
}